import type { PortalAudience } from '@/access/portalAccess.types';
import type { WorkersViewInput } from '@/modules/workers/workers.viewInput';

export type WorkerDetailTabKey =
  'details' | 'documents' | 'jobs' | 'applications' | 'notes' | 'activity';

export type WorkerDetailView = {
  audience: PortalAudience;
  tabs: WorkerDetailTabKey[];
  actions: {
    showLogoUpdate: boolean;
  };
  query: {
    worker: { fetch: boolean };
    applications: { fetch: boolean };
  };
};

const TENANT_TABS: WorkerDetailTabKey[] = [
  'details',
  'documents',
  'jobs',
  'applications',
  'notes',
  'activity',
];

const TAB_LABELS: Record<WorkerDetailTabKey, string> = {
  details: 'Details',
  documents: 'Documents',
  jobs: 'Jobs',
  applications: 'Applications',
  notes: 'Notes',
  activity: 'Activity',
};

export const getWorkerDetailTabs = (
  tabKeys: WorkerDetailTabKey[],
): { key: WorkerDetailTabKey; label: string }[] =>
  tabKeys.map((key) => ({ key, label: TAB_LABELS[key] }));

export const getWorkerDetailView = ({
  access,
}: WorkersViewInput): WorkerDetailView => {
  const { audience } = access;

  return {
    audience,
    tabs: TENANT_TABS,
    actions: {
      showLogoUpdate: true,
    },
    query: {
      worker: { fetch: true },
      applications: { fetch: true },
    },
  };
};
